import useTimeZoneClock from "hooks/useTimeZoneClock";
import { getBackgroundStyle } from "components/common/TableColor";
import { cdn } from "constants/common";
import moment from "moment";
import React from "react";
import { useTranslation } from 'react-i18next';

const TranslationViewTable = React.memo(({ item }) => {
  const { t } = useTranslation();
  const timeZone = useTimeZoneClock(item?.datetime);
  const formattedDate = moment(timeZone).format("MMMM DD YYYY");
  const formattedTime = moment(timeZone).format("hh:mm A");

  const InfoRow = ({ label, value, toLowerCase = "" }) => (
    <div className="row_detail_tab">
      <div className="label_view">
        <strong>{label}</strong>
      </div>
      <div className={`detail_view ${toLowerCase}`}>{value || "N/A"}</div>
    </div>
  );
  const rowDash1Style = {
    display: "flex",
    alignItems: "normal",
    width: "100%",
    gap: "1rem",
  };
  const rowDash2Style = {
    display: "block",
    alignItems: "normal",
    width: "100%",
    gap: "1rem",
  };
  const marginTopZero = {
    marginTop: 0,
  };
  const validSourceFiles = Array.isArray(item?.translation_files)
    ? item.translation_files.filter(
        (file) => file?.original_file_name || file?.file_name || file?.original_file
      )
    : [];
  return (
    //    Done
    <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
      <div className="row_dash_1" style={rowDash1Style}>
        <div className="card_table" style={marginTopZero}>
          <div className="Table_data_show Table_data_show1 pt-0">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.requestId')}:
                  </td>
                  <td class="bg-primary-secondary">#{item?.transid}</td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.requestedAt')}:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.created_at &&
                      moment(item?.created_at).format("MMM D, YYYY HH:mm:ss")}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.lastQuoteSent')}:
                  </td>
                  <td class="bg-primary-secondary">
                    {t('translationView.version')}: {item?.quotations && item?.quotations[0]?.version}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0 ">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.dueDate')}:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.translation_details?.due_date
                      ? moment(item?.translation_details?.due_date).format(
                          "MMM D, YYYY"
                        )
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.completedDate')}:
                  </td>
                  <td class="bg-primary-secondary">
                    {(item?.status == "Completed" &&
                      moment(item?.updated_at, "YYYY-MM-DD HH:mm:ss").format(
                        "MMM D, YYYY HH:mm:ss"
                      )) ||
                      "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="Table_data_show Table_data_show1 pt-0 ">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.sourceLanguage')}:
                  </td>
                  <td class="bg-primary-secondary">
                    {item.language?.name || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.targetLanguage')}:
                  </td>
                  <td className="bg-primary-secondary">
                    {Array.isArray(item.translation_target_languages) &&
                    item.translation_target_languages.length > 0
                      ? item.translation_target_languages
                          .map((tl) => tl.language?.name)
                          .filter(Boolean)
                          .join(", ")
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translation.notes')}:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.translation_details?.comment || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="card_table" style={marginTopZero}>
          <div className="Table_data_show Table_data_show1 pt-0">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.requesterName')}:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.requester_name}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.requesterEmail')}:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.translation_details?.requester_email}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.requesterPhone')}:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.translation_details?.requester_phone}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0 ">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.formattingRequired')}:
                  </td>
                  <td class="bg-primary-secondary">
                    {item.translation_details?.formatting ? "Yes" : "No"}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.rushRequired')}:
                  </td>
                  <td class="bg-primary-secondary">
                    {item.translation_details?.rush ? "Yes" : "No"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0 ">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {(() => {
                      const phase = item?.translation_details?.current_phase;
                      if (phase === "review") return "Total Pages";
                      if (phase === "other" || phase === "transcription") return "Total Audio Minutes";
                      return "Total Words";
                    })()}:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.translation_details?.total_quantity ?? item?.total_words_count ?? "N/A"}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.totalAmount')}:
                  </td>
                  {console.log(item, "item in view table")}
                  <td class="bg-primary-secondary">$ {item?.total_amount}</td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    {t('translationView.translator')}:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.interpreter?.user?.name || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="Table_data_show Table_data_show1 pt-0 ">
        <table class="bg-primary-secondary table">
          <tbody>
            <tr>
              <td class="bg-primary-secondary">
                {t('translationView.subAccount')}:
              </td>
              <td class="bg-primary-secondary text-capitalize">
                {item?.subclient?.subaccount_name || "N/A"}
              </td>
              <td class="bg-primary-secondary">
                {t('translationView.departmentName')}:
              </td>
              <td class="bg-primary-secondary text-capitalize">
                {item?.translation_details?.department?.department_name || "N/A"}
              </td>
            </tr>
          </tbody>
        </table>
        
        <table class="bg-primary-secondary table">
          <tbody>
            <tr>
              <td class="bg-primary-secondary" style={{ width: "40%" }}>
                {t('translationView.currentPhase')}:
              </td>
              <td class="bg-primary-secondary text-capitalize">
                {item?.translation_details?.current_phase?.replaceAll("_", " ")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Source Documents download section */}
      {validSourceFiles.length > 0 && (
        <div className="Table_data_show Table_data_show1 pt-0">
          <h5 style={{ marginBottom: 8, fontWeight: 600 }}>{t('translationView.sourceDocuments')}</h5>
          <table class="bg-primary-secondary table">
            <thead>
              <tr>
                <th class="bg-primary-secondary" style={{ width: "60%" }}>{t('translationView.fileName')}</th>
                <th class="bg-primary-secondary">{t('translationView.download')}</th>
              </tr>
            </thead>
            <tbody>
              {validSourceFiles.map((file, idx) => (
                <tr key={idx}>
                  <td class="bg-primary-secondary">{file?.original_file_name || file?.file_name || "N/A"}</td>
                  <td class="bg-primary-secondary">
                    {file?.original_file ? (
                      <a
                        href={`${cdn}${file.original_file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('translationView.download')}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {(item?.status === "Cancelled" ||
        item?.status === "Client Cancelled" ||
        item?.status === "Translator Declined") && (
        <div className="row_dash_1" style={rowDash1Style}>
          <div className="card_table" style={marginTopZero}>
            <div className="Table_data_show Table_data_show1 pt-0 ">
              <table class="bg-primary-secondary table">
                <tbody>
                  {(item?.status === "Cancelled" ||
                    item?.status === "Client Cancelled") && (
                    <>
                      <tr>
                        <td
                          class="bg-primary-secondary"
                          style={{ width: "20%" }}
                        >
                          {t('translationView.cancelledBy')}:
                        </td>
                        <td class="bg-primary-secondary">
                          {item.translation_details?.cancelled_by?.name ||
                            "N/A"}
                        </td>
                        <td
                          class="bg-primary-secondary"
                          style={{ width: "20%" }}
                        >
                          {t('translationView.cancelledAt')}:
                        </td>
                        <td class="bg-primary-secondary">
                          {moment(
                            item?.translation_details?.cancelled_at,
                            "YYYY-MM-DD HH:mm:ss"
                          ).format("MMM D, YYYY HH:mm:ss") || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={1}
                          className="bg-primary-secondary"
                          style={{ width: "20%" }}
                        >
                          {t('translationView.cancellationReason')}:
                        </td>
                        <td colSpan={3} className="bg-primary-secondary">
                          {item?.translation_details?.cancel_reason}
                        </td>
                      </tr>
                    </>
                  )}
                  {item?.status === "Translator Declined" && (
                    <tr>
                      <td
                        colSpan={1}
                        className="bg-primary-secondary"
                        style={{ width: "20%" }}
                      >
                        {t('translationView.declineReason')}:
                      </td>
                      <td colSpan={3} className="bg-primary-secondary">
                        {item?.translation_details?.translation_decline_reason}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {item?.translation_custom_work_order && (
        <div className="card_table">
          <div className="row_main_head">
            <h2 className="main_heading" style={{marginBottom: "0px"}}>{t('translationView.customWorkOrder')}</h2>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0 overflow-auto">
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary">Translation Rate:</td>
                  <td className="bg-primary-secondary">
                    ${Number(item.translation_custom_work_order.translation_rate ?? 0).toFixed(2)}
                  </td>
                  <td className="bg-primary-secondary">Editing Rate:</td>
                  <td className="bg-primary-secondary">
                    ${Number(item.translation_custom_work_order.editing_rate ?? 0).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary">DTP/Formatting Rate:</td>
                  <td className="bg-primary-secondary">
                    ${Number(item.translation_custom_work_order.dtp_rate ?? 0).toFixed(2)}
                  </td>
                  <td className="bg-primary-secondary">Review Rate:</td>
                  <td className="bg-primary-secondary">
                    ${Number(item.translation_custom_work_order.review_rate ?? 0).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary">Audio Recording Rate:</td>
                  <td className="bg-primary-secondary">
                    ${Number(item.translation_custom_work_order.audio_recording_rate ?? 0).toFixed(2)}
                  </td>
                  <td className="bg-primary-secondary">Transcription Rate:</td>
                  <td className="bg-primary-secondary">
                    ${Number(item.translation_custom_work_order.transcription_rate ?? 0).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
});

export default TranslationViewTable;
